import { createSlice } from '@reduxjs/toolkit';
const successMessageSlice = createSlice({
  name: 'successMessage',
  initialState: {
    message: '',
    visible: false,
  },
  reducers: {
    setSuccessMessage: (state, action) => {
      state.message = action.payload.message;
      state.visible = true;
    },
    hideSuccessMessage: (state) => {
      state.visible = false;
      state.message = '';
    },
  },
});

export const { setSuccessMessage, hideSuccessMessage } = successMessageSlice.actions;

export const selectSuccessMessage = (state) => state.successMessage;

export default successMessageSlice.reducer;
